import { Link } from 'react-router-dom';
import ResourceCard from '@/components/base/ResourceCard';
import { latestResources } from '@/mocks/resources';

export default function LatestGrid() {
  return (
    <section className="mx-auto w-full px-4 md:px-8">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            近期上架的国语影音资源，持续更新中
          </p>
        </div>
        <Link
          to="/category/movie"
          className="hidden cursor-pointer items-center gap-1 text-sm font-label text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex"
        >
          查看全部
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
        {latestResources.map((item) => (
          <ResourceCard key={item.id} resource={item} />
        ))}
      </div>
    </section>
  );
}